import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const BomLineItems = (props) => {
  const name = 'bom_line_items';

  const {
    label,
    errorMessage,
    parameters,
    inputId,
    tooltip,
    groupName,
    onChangeParameter,
    required,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      name={name}
      disabled={disabled}
      label={label}
      inputId={inputId}
      value={parameters[name]}
      tooltip={tooltip}
      required={required}
      groupName={groupName}
      onChange={onChange}
      errorMessage={errorMessage} />
  );
};

BomLineItems.defaultProps = {
  label: Spree.translations.parameters.bom_line_items,
  tooltip: Spree.helpForParameters.bom_line_items,
  required: true,
  inputId: 'bom-line-items',
};

export default BomLineItems;
